import React, { FC, useEffect } from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";

import { getServiceCategory } from "../../apis/get-service-category";

import { Button, FaIcons, Link, Section } from "@in/component-library";
import Page from "../../components/page/page";
import { useLayout } from "../../hooks/use-layout";

interface ServiceCategoryParams extends Record<string, string | undefined> {
  slug: string;
}

const ServiceCategory: FC = () => {
  const { slug } = useParams<ServiceCategoryParams>();
  const { translations } = useLayout();

  const { data, error } = useSWR(`service-categories/${slug}`, getServiceCategory);

  useEffect(() => {
    if (data?.title && translations.applicationsHeader && translations.companyName) {
      document.title = `${data.title} - ${translations.applicationTitle} - ${translations.companyName}`;
    }
  }, [translations, data]);

  return (
    <Page inputs={[data]} errors={[error]}>
      <Section>
        <h1 className="service-category__title">{data?.title}</h1>
        {data?.descriptionRich ? (
          <div className="service-category__subtitle" dangerouslySetInnerHTML={{ __html: data.descriptionRich }} />
        ) : (
          data?.description && <h3 className="service-category__subtitle">{data?.description}</h3>
        )}
        <div className="service-category__services">
          {data?.services &&
            data.services.map((service) => (
              <div className="service-category__service" key={service.id}>
                <p className="service-category__service-title">{service.name}</p>
                <p className="service-category__service-description">{service.description}</p>

                <Link className="service-category__service-link" href={service.url}>
                  {service.linkText}
                </Link>

                {service.applicationForms &&
                  service.applicationForms.map((applicationForm) => (
                    <p key={applicationForm.url}>
                      <Button
                        className="service-category__service-button"
                        onClick={() => window.location.replace(applicationForm.url)}
                        variant="outlined"
                        iconName={FaIcons.LongArrowRight}
                        iconPosition="right"
                      >
                        {applicationForm.name}
                      </Button>
                    </p>
                  ))}
              </div>
            ))}
        </div>
      </Section>
    </Page>
  );
};

export default ServiceCategory;